module.exports = __webpack_public_path__ + "img/Magazine_rack.2adf8884.png";